import { useEffect, useMemo } from "react";
import { UserChkToken } from "../../api/userApi";
import store from "../../store/store";
import { UserDetailsAction } from "../../store/action";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * @param {string} userName
 */

const useAuthCheck = (userName) => {
  const navigate = useNavigate();
  const location = useLocation();

  // 🔹 localStorageToken을 useMemo로 최적화
  const localStorageToken = useMemo(() => {
    const tokenString = localStorage.getItem("luca_userDetails");
    return tokenString ? JSON.parse(tokenString) : null;
  }, [localStorage.getItem("luca_userDetails")]); // 🔥 localStorage 변경 시 업데이트됨

  useEffect(() => {
    const checkDuplicateLogin = async () => {
      if (!userName || !localStorageToken) return; // userName 또는 토큰이 없으면 실행 안 함

      const params = { user_id: userName };
      console.log("chk params: " + params);

      if (location.pathname !== "/") {
        try {
          const serverResponse = await UserChkToken(params);

          console.log("chk serverResponse: " + serverResponse);

          // if (!serverResponse || !serverResponse.token) {
          //   console.error("🔴 서버 응답에 토큰이 없습니다.");
          //   return;
          // }

          if (!Array.isArray(serverResponse) || serverResponse.length === 0) {
            console.error("🔴 서버 응답이 비어 있거나 배열이 아닙니다.");
            return;
          }

          const serverToken = serverResponse[0]?.token; // 🔥 서버에서 받은 토큰

          if (!serverToken || localStorageToken.token !== serverToken) {
            console.warn("🔴 중복 로그인 감지: 로컬 & 서버 토큰 불일치!");
            store.dispatch(UserDetailsAction(null));
            localStorage.removeItem("luca_userDetails");
            navigate(`/`);
          } else {
            console.log("✅ 토큰이 일치합니다. 정상 로그인 상태 유지.");
          }
        } catch (error) {
          console.error("🔴 중복 로그인 체크 중 오류 발생:", error);
        }
      }
    };

    checkDuplicateLogin();
  }, [userName, localStorageToken, location.pathname, navigate]); // 🔥 userName, localStorageToken, 경로 변경 시 실행
};

export default useAuthCheck;
